import { FetchingStrategy, FetchingIndicatorComponent } from '../../../types';

export const createFetchingStrategy = (
  isFetching: boolean,
  FetchingIndicator: FetchingIndicatorComponent
): FetchingStrategy => ({
  isFetching,
  FetchingIndicator,
});
